<template>
	<div class="trainer">
    <div class="trainer__header">
      <a href="#" @click.prevent="$parent.commitVal(false, 'start')">Остановить</a>
    </div>

    <div class="trainer__body">
      <abacus
        :can-change="true"
        :axis-qnt="params.num_axis*1"
        :show-clear="true"
        :show-sum="true"
        :show-numbers="params.show_numbers"
      ></abacus>
    </div>
	</div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import { mix } from "./../mixin";
  import abacus from "./abacus";

  export default {
    name: "game",
    mixins: [
      mix
    ],
    components: {
      abacus
    },
    computed: {
      ...mapState({
        params: state => state.train.abacus_params
      })
    }
  }
</script>